import type { LangStrings } from './en';

export const fr: LangStrings = {
  back: 'RETOUR',
  next: 'SUIVANT',
  retry: 'RÉESSAYER',
  replay: 'REJOUER',
  sector: 'SECTEUR',
  sectors: 'SECTEURS',
  levels: 'NIVEAUX',
  cleared: 'TERMINÉ',
  open: 'OUVERT',
  locked: 'VERROUILLÉ',
  tba: 'TBA',
  slot_reserved: 'RÉSERVÉ',
  sfx_on: 'SFX ON',
  sfx_off: 'SFX OFF',
  reset_progress: 'EFFACER PROGRÈS',
  wiped_reloading: 'EFFACÉ, RECHARGEMENT…',
  got_it: '› COMPRIS ‹',

  boot_eyebrow: 'PROTOCOLE CASCADE  //  BUILD',
  boot_tagline: 'UN TAP. UNE CASCADE. AUCUN REJET.',
  boot_subtitle: '信号崩壊  ·  LOGIQUE DE CASCADE',
  boot_cta: '› TAPE POUR LANCER ‹',
  boot_region: 'RÉGION ▣ /7',
  boot_top_left: 'HAYTERWAVE//SYSCORE',
  boot_top_right_status: '0xC7A5 // EN LIGNE',

  menu_header_subtitle: 'NØDUS / SÉLECTION.SECTEUR',
  menu_engine_label: 'moteur d\'effondrement de signal',
  menu_signals_down: 'signaux abattus',
  menu_tap_chapter: 'TAPE UN CHAPITRE POUR ENTRER',
  menu_language_label: 'LANGUE',

  chapter_signals_down: 'signaux abattus',
  chapter_tba_label: '0xTBA',
  chapter_coda_name: 'CODA',
  chapter_coda_tagline: 'Rien de nouveau. Tout combiné.',

  hud_tap_to_breach: '▾  tape un nœud pour percer  ▾',
  hud_tap_to_skip: "passer  ▸▸",
  hud_drag_zoom_help: 'glisse pour déplacer · roue/pince pour zoomer',
  hud_required: 'REQUIS',
  hud_core_online: 'NOYAU ACTIF',
  hud_core_down: 'NOYAU À TERRE',

  tut_tap_any_node: 'TAPE N\'IMPORTE QUEL NŒUD',
  tut_they_all_work: 'tous fonctionnent ici',

  brief_eyebrow: '◂ BRIEFING ▸',
  brief_title: 'UN TAP.\nUNE CASCADE.',
  brief_line_1: '› Tu as exactement UN tap.',
  brief_line_2: '› Il déclenche une réaction en chaîne dans le réseau.',
  brief_line_3: '› Fais tomber chaque REQUIS (diamant cyan) pour gagner.',
  brief_line_4: '› Ne laisse jamais une impulsion toucher un PROTÉGÉ (rouge).',
  brief_begin: '› DÉMARRER LE BRIEFING ‹',

  result_win_headline: 'SYSTÈME EFFONDRÉ',
  result_fail_headline: 'CASCADE ÉCHOUÉE',
  result_first_clear: '› PREMIÈRE RÉUSSITE ‹',
  result_try_label: '› ESSAIE',
  result_cleared_suffix: 'TERMINÉ',
  result_aborted_suffix: 'RUN INTERROMPUE',
  result_win_body_template: '{ticks} ticks. {nodes} nœuds abattus.',

  fail_protected_overload: 'Nœud protégé en surcharge. La cascade a touché ce qu\'il ne fallait pas.',
  fail_forbidden_trigger: 'Une ligne interdite a porté un signal. Alarme déclenchée.',
  fail_required_not_reached: 'Un nœud requis n\'a jamais reçu d\'impulsion. La chaîne ne l\'a pas atteint.',
  fail_required_under_threshold: 'Un requis n\'a pas reçu assez d\'impulsions. La décroissance a tué la première avant la seconde.',
  fail_core_not_collapsed: 'Le noyau a survécu. La cascade s\'est dissipée avant de l\'atteindre.',
  fail_core_under_threshold: 'Le noyau a reçu des impulsions mais pas assez, pas de convergence à temps.',
  fail_core_shielded: 'Impulsions du noyau bloquées. Un bouclier était encore actif.',
  fail_chain_died: 'La chaîne est morte avant d\'atteindre quoi que ce soit.',
  fix_protected_overload: 'Choisis un démarreur dont la cascade n\'atteint jamais le danger rouge. Trace d\'abord les sorties.',
  fix_forbidden_trigger: 'Évite les démarreurs qui tirent VERS un câble rouge pointillé. L\'alarme se déclenche dès le contact.',
  fix_required_not_reached: 'Ton démarreur ne se connecte pas à ce nœud. Regarde les flèches, les câbles directionnels ne vont que dans un sens.',
  fix_required_under_threshold: 'Trouve une route qui livre deux impulsions à ce nœud, un diviseur ou deux chemins convergents suffit.',
  fix_core_not_collapsed: 'Il faut plus de convergence vers le noyau. Diviseurs, condensateurs et relais existent pour l\'alimenter.',
  fix_core_under_threshold: 'Les impulsions arrivent trop lentement. Utilise des diviseurs pour empiler, ou fais tout arriver au même tick.',
  fix_core_shielded: 'Fais tomber chaque bouclier avant tout tir mortel. Un câble de délai arrivant tard est un moyen propre.',
  fix_chain_died: 'Ton démarreur ne se connecte qu\'à un seul nœud. Prends-en un au centre du réseau.',

  popup_new_node: '◂ NOUVEAU TYPE DE NŒUD ▸',
  popup_new_wire: '◂ NOUVEAU TYPE DE CÂBLE ▸',

  node_normal_title: 'NŒUD',
  node_normal_tagline: 'L\'unité de base. Tape pour lancer une cascade.',
  node_normal_b1: 'S\'effondre à la première impulsion reçue.',
  node_normal_b2: 'Émet une impulsion sur chaque câble sortant ouvert.',
  node_normal_b3: 'Pas de seuil, un coup et il disparaît.',

  node_required_title: 'REQUIS',
  node_required_tagline: 'Tu dois faire tomber chaque REQUIS pour gagner.',
  node_required_b1: 'Diamant cyan. Pulse doucement au repos pour être visible.',
  node_required_b2: 'Certains demandent 2+ impulsions dans la même fenêtre.',
  node_required_b3: 'Manque-en un seul et la run échoue.',
  node_required_note: 'Un petit anneau de points montre sa progression de charge.',

  node_protected_title: 'PROTÉGÉ',
  node_protected_tagline: 'Touche-le et toute la run meurt.',
  node_protected_b1: 'Croix rouge de danger. Marqué d\'équerres aux angles.',
  node_protected_b2: 'Toute impulsion qui le touche = ÉCHEC instantané.',
  node_protected_b3: 'Planifie une route qui ne le nourrit jamais.',

  node_relay_title: 'RELAIS',
  node_relay_tagline: 'Ouvre les câbles verrouillés en s\'effondrant.',
  node_relay_b1: 'Chevron doré. Ses cibles sont des câbles VERROUILLÉS pointillés.',
  node_relay_b2: 'Quand le relais tombe, ses câbles verrouillés s\'allument.',
  node_relay_b3: 'Utile pour révéler une route vers un nœud gardé.',

  node_shield_title: 'BOUCLIER',
  node_shield_tagline: 'Un garde du corps. Absorbe les coups pour un autre nœud.',
  node_shield_b1: 'Anneau hexagonal vert autour du nœud protégé.',
  node_shield_b2: 'Une impulsion directe sur un nœud blindé NE FAIT RIEN.',
  node_shield_b3: 'Fais tomber le bouclier d\'abord, puis livre le tir mortel.',
  node_shield_note: 'Les câbles de DÉLAI (doré pointillé) sont parfaits pour synchroniser un tir post-bouclier.',

  node_splitter_title: 'DIVISEUR',
  node_splitter_tagline: 'Multiplie les impulsions sur toutes ses sorties.',
  node_splitter_b1: 'Fourche magenta. Une impulsion entre → N impulsions par sortie.',
  node_splitter_b2: 'Le marqueur X montre son facteur de division.',
  node_splitter_b3: 'Fournit les coups multiples qu\'un NOYAU à seuil élevé exige.',

  node_capacitor_title: 'CONDENSATEUR',
  node_capacitor_tagline: 'Stocke une impulsion puis la ré-émet, un tampon.',
  node_capacitor_b1: 'Symbole jaune de condensateur. Transmet une impulsion 3 ticks plus tard.',
  node_capacitor_b2: 'Considère-le comme un DÉLAI intégré dans la route.',
  node_capacitor_b3: 'Permet à une impulsion d\'arriver APRÈS la chute d\'un bouclier.',

  node_core_title: 'NOYAU',
  node_core_tagline: 'L\'objectif. Seuil haut, décroissance rapide.',
  node_core_b1: 'Réacteur violet. Demande beaucoup d\'impulsions convergentes pour tomber.',
  node_core_b2: 'La charge DÉCROÎT, les impulsions doivent arriver groupées.',
  node_core_b3: 'Souvent protégé par des boucliers. Tombe-les, puis inonde le noyau.',
  node_core_note: 'Un niveau avec NOYAU se gagne en l\'effondrant. Les requis (s\'il y en a) comptent aussi.',

  wire_directional_title: 'CÂBLE DIRECTIONNEL',
  wire_directional_tagline: 'Conducteur à sens unique. Cyan avec pointe de flèche.',
  wire_directional_b1: 'L\'impulsion ne voyage que dans le sens de la flèche.',
  wire_directional_b2: 'Tape du mauvais côté de la flèche et rien ne coule.',
  wire_directional_b3: 'Suis les flèches depuis ton démarreur jusqu\'au bout.',

  wire_delay_title: 'CÂBLE DE DÉLAI',
  wire_delay_tagline: 'Doré pointillé. L\'impulsion arrive 3 ticks plus tard.',
  wire_delay_b1: 'Utile pour le timing, pose une impulsion APRÈS la chute d\'un bouclier.',
  wire_delay_b2: 'Ou pour empiler deux impulsions sur un nœud à seuil élevé.',
  wire_delay_b3: 'Rate le timing et la première impulsion se dégrade avant.',

  wire_locked_title: 'CÂBLE VERROUILLÉ',
  wire_locked_tagline: 'Gris pointillé + cadenas. Fermé jusqu\'à ce qu\'on l\'ouvre.',
  wire_locked_b1: 'Un RELAIS contrôle chaque câble verrouillé.',
  wire_locked_b2: 'Quand le relais s\'effondre, ses câbles verrouillés s\'ouvrent.',
  wire_locked_b3: 'Ne gaspille pas un tap à essayer d\'en alimenter un directement.',

  wire_forbidden_title: 'CÂBLE INTERDIT',
  wire_forbidden_tagline: 'ROUGE pointillé avec croix. Touche-le = échec instantané.',
  wire_forbidden_b1: 'Toute impulsion, même de transit, déclenche l\'alarme.',
  wire_forbidden_b2: 'Surveille-les sur les sorties de chaque démarreur.',
  wire_forbidden_b3: 'Choisis un démarreur dont la route ne touche JAMAIS le rouge.',

  wire_burn_title: 'CÂBLE INCENDIAIRE',
  wire_burn_tagline: 'Orange laiton. Conducteur à usage unique, brûle après une impulsion.',
  wire_burn_b1: 'Porte exactement UNE impulsion, puis meurt pour toujours.',
  wire_burn_b2: 'Planifie son usage unique avec soin, pas de seconde chance.',
  wire_burn_b3: 'Une fois brûlé, aucune cascade ne peut le retraverser.',

  callout_required_crashed: 'REQUIS À TERRE',
  callout_core_breached: 'NOYAU PERCÉ',
  callout_shield_dropped: 'BOUCLIER TOMBÉ',
  callout_relay_opened: 'RELAIS OUVERT',
  callout_protected_hit: 'PROTÉGÉ TOUCHÉ',

  // ── Beta: settings ─────────────────────────────────────────
  menu_settings: 'SETTINGS',
  settings_title: 'SETTINGS',
  settings_sound: 'Sound',
  settings_haptics: 'Haptics',
  settings_haptics_note: 'device only',
  settings_on: 'ON',
  settings_off: 'OFF',
  settings_replay_tutorials: 'Replay tutorials',
  settings_reset_progress: 'Reset all progress',
  settings_reset_confirm: 'TAP AGAIN TO WIPE',
  settings_done: 'DONE',

  // ── Beta: achievements / share ─────────────────────────────
  menu_achievements: 'AWARDS',
  ach_title: 'ACHIEVEMENTS',
  ach_new: 'ACHIEVEMENT UNLOCKED',
  ach_locked: 'LOCKED',
  share_button: 'SHARE',
  share_copied: 'Copied to clipboard',

  // ── Beta: daily challenge ──────────────────────────────────
  daily_title: 'DAILY',
  daily_tagline: 'One fresh puzzle every day. Keep the streak alive.',
  daily_new: 'NEW TODAY',
  daily_keep: 'KEEP IT ALIVE',
  menu_play_first: 'LEVEL 1 FIRST',
  daily_done: 'SOLVED ✓',
  daily_solved: 'DAILY SOLVED',
  daily_streak: 'STREAK',

  // ── Beta: ads / lives / hints / stats ───────────────────────
  ad_label: 'ADVERTISEMENT',
  ad_house_tagline: 'One tap. One breach. Infinite levels.',
  ad_rewarded_watching: 'Watch to earn your reward',
  ad_interstitial_watching: 'Your run continues in a moment',
  ad_rewarded_done: 'Reward unlocked',
  ad_interstitial_done: 'Thanks for playing',
  ad_reward_in: 'Reward in {n}s',
  ad_claim: 'CLAIM',
  ad_continue: 'CONTINUE',
  lives_label: 'LIVES',
  run_over_headline: 'OUT OF LIVES',
  run_over_body: 'Your run is on the line. Watch an ad for a life, or bank this run.',
  watch_for_life: 'AD  +1 LIFE',
  bank_run: 'BANK RUN',
  life_lost: '-1 LIFE',
  hint_button: 'HINT',
  hint_confirm_title: 'WATCH AD FOR A HINT?',
  hint_confirm_body: 'Rules out one breach point that does NOT solve this level. It never shows you the answer.',
  hint_yes: 'WATCH AD',
  hint_removed: 'One wrong breach point ruled out',
  hint_none_left: 'Nothing left to rule out',
  no_thanks: 'NO THANKS',
  stats_title: 'STATISTICS',
  menu_stats: 'STATS',
  stats_levels_completed: 'Levels completed',
  stats_endless_best: 'Endless best',
  stats_best_streak: 'Best streak',
  stats_fail_rate: 'Fail rate',
  stats_wins: 'Wins',
  stats_fails: 'Fails',
  stats_hints_used: 'Hints used',
  stats_ads_watched: 'Ads watched',
  stats_close: 'CLOSE',
  // ── Added with the redesign (machine draft, see TRANSLATIONS-DRAFT.md) ──
  result_map_tapped: 'Ton tap',
  result_map_broke: 'Échec ici',
  result_map_answer: 'Fonctionne',
  result_show_answer: 'Afficher la solution',
  menu_endless_line: 'Niveaux générés, trois vies. Plus on descend, plus ça mord.',
  menu_best: 'Record LV {n}',
  menu_best_streak: 'Record LV {n}  ·  série ×{s}',
  menu_resume: 'Reprendre LV {n}',
  menu_start: 'Commencer LV 1',
  result_run_total: 'Total de la série {n}',
  result_streak: 'Série ×{n}',
  result_streak_wins: '{n} victoires d\'affilée',
  legend_title: 'Légende',
  legend_nodes: 'NŒUDS',
  legend_wires: 'FILS',
  legend_close: 'Touche n\'importe où pour fermer',
  settings_sync_now: 'Synchroniser ({who})',
  settings_sign_in: 'Connecte-toi pour synchroniser',
  settings_sign_out: 'Se déconnecter',

};
